import { Layers } from "lucide-react";
import { useT, useTRaw, useImg } from "@/context/ContentContext";
import { AREAS } from "./HomeData";

export default function HomeAreas() {
    const t = useT();
    const tRaw = useTRaw();
    const img = useImg();
    return (
        <section className="py-16 sm:py-24">
            <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
                <div className="eyebrow mb-6"><Layers className="w-3.5 h-3.5" /> Áreas de atuação</div>
                <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-[1.05] max-w-3xl">
                    Três áreas. Um <span className="font-serif-italic text-[hsl(var(--copper))]">método</span>.
                </h2>
                <div className="grid md:grid-cols-3 gap-4 mt-12">
                    {AREAS.map((a, idx) => {
                        const cmsImg = img(`home.area${idx + 1}.image`, a.img);
                        const cmsTitle = t(`home.area${idx + 1}.title`, a.title);
                        const cmsTitleRaw = tRaw(`home.area${idx + 1}.title`, a.title);
                        const cmsDesc = t(`home.area${idx + 1}.desc`, a.desc);
                        return (
                            <div key={a.n} className="card-stone card-stone-hover p-4" data-testid={`area-${a.n}`}>
                                <div className="rounded-2xl overflow-hidden aspect-[4/3] mb-5">
                                    <img src={cmsImg} alt={cmsTitleRaw} className="w-full h-full object-cover" loading="lazy" />
                                </div>
                                <div className="flex items-baseline gap-3 mb-2">
                                    <span className="font-mono text-xs text-[hsl(var(--copper))]">{a.n}</span>
                                    <h3 className="font-display text-2xl font-bold">{cmsTitle}</h3>
                                </div>
                                <p className="text-[hsl(var(--graphite))]/70 leading-relaxed">{cmsDesc}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
